import React, { useState } from "react";
import { Card, Grid, Icon, InputText, Link, Picture, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import lists from "~/lib/lists";
import { AppEnum } from "~/types/enums";
import Markdown from "~/components/Markdown";
import { resolveSlackChannelName } from "~/lib/helpers";
import styled, { useTheme } from "styled-components";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryCommunicationCard = _ref => {
  let {
    communication,
    initialLimit = 3,
    ...rest
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  let tempCommunication = communication;
  if (!tempCommunication.length) {
    return null;
  }
  const exceededLimit = tempCommunication.length > initialLimit;
  const exceededLimitBy = limit && tempCommunication.length > limit ? tempCommunication.length - limit : undefined;
  if (exceededLimitBy) {
    tempCommunication = tempCommunication.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const filteredCommunication = tempCommunication.filter(_ref2 => {
    let {
      name
    } = _ref2;
    return query === "" || name.toLowerCase().includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredCommunication.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4,
    template: "1.7rem 1fr"
  }, filteredCommunication.map(channel => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: channel.id
    }, /*#__PURE__*/React.createElement(Picture, {
      border: "squared",
      src: lists.common.apps.logos(theme)[AppEnum.SLACK],
      width: "1.7rem",
      height: "1.7rem",
      s: {
        mt: 2
      }
    }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Markdown, {
      text: resolveSlackChannelName(channel.name, channel.url),
      color: theme.colors.text.primary,
      fontSize: 4,
      weight: "semiBold",
      components: {
        a: _ref3 => {
          let {
            href = "",
            children
          } = _ref3;
          return /*#__PURE__*/React.createElement(Link, {
            href: href,
            color: theme.colors.text.primary
          }, children.join(""));
        }
      }
    }), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      weight: "semiBold"
    }, t("TopicSummaryCard.footprints", {
      count: channel.footprintCount
    }))));
  })) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No channels"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: theme.colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryCommunicationCard;